import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{class:{ 'd-flex': _vm.$vuetify.breakpoint.mdAndUp },staticStyle:{"height":"100vh"}},[_c(VRow,{attrs:{"align":"center"}},[_c(VCol,{staticClass:"d-flex justify-center"},[_c('login-form',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isRedirecting),expression:"!isRedirecting"}],attrs:{"next-url":_vm.nextUrl}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }